module.exports = __webpack_public_path__ + "static/media/chestnyznak.bbb7e1ea.svg";